// extracted by mini-css-extract-plugin
export var active = "_86-a";
export var activeIndicator = "_86-9";
export var disabled = "_86-b";
export var fullWidth = "_86-2";
export var lg = "_86-7";
export var md = "_86-6";
export var redoButtonTabGroup = "_86-0";
export var sm = "_86-5";
export var tabButton = "_86-4";
export var tabButtonsContainer = "_86-1";
export var themeDestructive = "_86-d";
export var themeNormal = "_86-c";
export var themeSuccess = "_86-e";
export var xl = "_86-8";
export var xs = "_86-3";